module.exports = __webpack_public_path__ + "img/2024_bnr1160_3.1d5ff2c.png";